var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"InputSelect FiledWrapper",class:{'Ready':_vm.m_State=='Ready','Input':_vm.m_State=='Input'}},[_c('div',{staticClass:"LabelPart Field",on:{"mousedown":_vm.OnMouseDown}},[_c('t-label',{ref:"InputSelectLabel",staticClass:"Field",attrs:{"value":_vm.m_Value,"text":_vm.m_ValueText,"OptionName":_vm.OptionName,"Options":_vm.Options,"nullable":_vm.nullable,"title":_vm.title,"ComplexOptionName":_vm.ComplexOptionName}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.m_Value != null),expression:"m_Value != null"}],staticClass:"ClearIcon",on:{"click":_vm.OnClearButtonClick}},[_vm._v("✗")]),_vm._v(" "),_c('div',{staticClass:"InputPart"},[_c('t-inputquery',{ref:"InputSelectInput",staticStyle:{"white-space":"pre-wrap"},attrs:{"Strict":"true","value":_vm.m_Text,"disabled":_vm.disabled,"QueryApiUrl":_vm.QueryApiUrl,"PlaceHolder":"請輸入關鍵字","CreateInputTextHandler":function (text,row) {
                                                                                                                        var text = '' ;
                                                                                                                        if(row != null)
                                                                                                                        {
                                                                                                                            text =  row.Text ;
                                                                                                                        }

                                                                                                                        return text;
                                                                                                                   },"CreateOptionTextHandler":_vm.CreateOptionTextHandler,"CreateQueryRequestHandler":function (text,row){
return  {

                          Keyword:text ,
                          Text:text ,

                          Query : {
                              ValueSet :
                              {
                                  Keyword:text ,
                                  Text:text ,
                              } ,
                          }

                                                                                                                              };
                                      }},on:{"blur":_vm.OnBlur,"change":function (text,row){
                          if(row != null){
                              var optionValue = null;
                              var messageElement;

                              _vm.m_State = 'Ready';

                              _vm.$forceUpdate();


                              if(_vm.GetRowValueHandler != null){
                                   _vm.m_Value = _vm.GetRowValueHandler(row);

                                   this$1.$emit('input',_vm.m_Value);
                                   this$1.$emit('change',_vm.m_Value);
                              }


                              messageElement = _vm.$el.querySelector(':scope .error_message');


                              if(messageElement != null){
                                   messageElement.innerHTML = '';
                              } 

                              _vm.$refs.InputSelectInput.Clear();


                              this$1.LoadText();
                          }
                      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }